export default __webpack_public_path__ + "media/images/landing-2-550x420-f1a76a5a43469a06fcb6db98e4bb7f09.jpg";